/* Volta theme v1.0.0 */
(() => {
  const $ = (s, r = document) => r.querySelector(s);
  const $$ = (s, r = document) => Array.from(r.querySelectorAll(s));
  const parse = (html) => new DOMParser().parseFromString(html, 'text/html');
  const debounce = (fn, wait = 250) => {
    let t;
    return (...args) => { clearTimeout(t); t = setTimeout(() => fn(...args), wait); };
  };
  const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  let lastFocus = null;
  const openDialog = (d, trigger) => {
    if (!d || d.open) return;
    lastFocus = trigger || document.activeElement;
    d.showModal();
    document.documentElement.style.overflow = 'hidden';
  };
  const closeDialog = (d) => { if (d && d.open) d.close(); };

  document.addEventListener('close', (e) => {
    if (e.target.tagName !== 'DIALOG') return;
    if (!$('dialog[open]')) document.documentElement.style.overflow = '';
    if (lastFocus && document.contains(lastFocus)) lastFocus.focus();
  }, true);

  function toast(message) {
    const el = $('[data-toast]');
    if (!el) return;
    el.textContent = message;
    el.classList.add('is-visible');
    clearTimeout(el._t);
    el._t = setTimeout(() => el.classList.remove('is-visible'), 2600);
  }

  document.addEventListener('click', (e) => {
    const opener = e.target.closest('[data-open-dialog]');
    if (opener) {
      const d = document.getElementById(opener.dataset.openDialog);
      if (d) { e.preventDefault(); openDialog(d, opener); if (d.id === 'SearchModal') setTimeout(() => $('[data-predictive-input]', d)?.focus(), 50); }
      return;
    }
    const closer = e.target.closest('[data-close-dialog]');
    if (closer) { closeDialog(closer.closest('dialog')); return; }
    if (e.target.tagName === 'DIALOG') {
      const r = e.target.getBoundingClientRect();
      const inside = e.clientX >= r.left && e.clientX <= r.right && e.clientY >= r.top && e.clientY <= r.bottom;
      if (!inside || e.target.classList.contains('search-modal')) closeDialog(e.target);
    }
  });

  document.addEventListener('click', (e) => {
    $$('[data-menu-details][open]').forEach((d) => { if (!d.contains(e.target)) d.removeAttribute('open'); });
  });
  document.addEventListener('keyup', (e) => {
    if (e.key !== 'Escape') return;
    const open = $('[data-menu-details][open]');
    if (open) { open.removeAttribute('open'); $('summary', open).focus(); }
  });
  document.addEventListener('toggle', (e) => {
    if (!e.target.matches || !e.target.matches('[data-menu-details]') || !e.target.open) return;
    $$('[data-menu-details][open]').forEach((d) => { if (d !== e.target) d.removeAttribute('open'); });
  }, true);

  function initAnnouncement(scope) {
    $$('[data-announcement]:not([data-bound])', scope).forEach((bar) => {
      bar.dataset.bound = 'true';
      const items = $$('.announcement__item', bar);
      if (items.length < 2 || reducedMotion) return;
      let i = 0;
      let paused = false;
      bar.addEventListener('mouseenter', () => { paused = true; });
      bar.addEventListener('mouseleave', () => { paused = false; });
      setInterval(() => {
        if (paused) return;
        items[i].classList.remove('is-active');
        i = (i + 1) % items.length;
        items[i].classList.add('is-active');
      }, (parseInt(bar.dataset.speed, 10) || 5) * 1000);
    });
  }

  document.addEventListener('change', (e) => {
    if (e.target.matches('[data-auto-submit]')) e.target.form.submit();
  });

  document.addEventListener('click', async (e) => {
    const btn = e.target.closest('[data-copy-link]');
    if (!btn) return;
    try { await navigator.clipboard.writeText(btn.dataset.copyLink); toast(window.theme.strings.copied); } catch (err) {}
  });

  document.addEventListener('click', (e) => {
    const btn = e.target.closest('.qty button[data-qty]');
    if (!btn) return;
    const input = $('input', btn.closest('.qty'));
    const min = parseInt(input.min, 10) || 0;
    const max = input.max ? parseInt(input.max, 10) : Infinity;
    let val = parseInt(input.value, 10) || 0;
    val = btn.dataset.qty === 'plus' ? Math.min(val + 1, max) : Math.max(val - 1, min);
    input.value = val;
    input.dispatchEvent(new Event('change', { bubbles: true }));
  });

  const Cart = {
    drawer: () => document.getElementById('CartDrawer'),
    sectionIds() {
      const ids = [];
      if (this.drawer()) ids.push('cart-drawer');
      const page = $('[data-cart-page]');
      if (page) ids.push(page.dataset.sectionId);
      return ids;
    },
    render(sections) {
      if (!sections) return;
      const drawer = this.drawer();
      if (drawer && sections['cart-drawer']) {
        const fresh = $('#CartDrawer', parse(sections['cart-drawer']));
        if (fresh) drawer.innerHTML = fresh.innerHTML;
      }
      const page = $('[data-cart-page]');
      if (page && sections[page.dataset.sectionId]) {
        const fresh = $('[data-cart-page]', parse(sections[page.dataset.sectionId]));
        if (fresh) page.innerHTML = fresh.innerHTML;
      }
    },
    updateCount(count) {
      $$('[data-cart-count]').forEach((el) => { el.textContent = count > 0 ? count : ''; });
    },
    async refreshCount() {
      const r = await fetch(`${window.theme.routes.cart_url}.js`, { headers: { Accept: 'application/json' } });
      const cart = await r.json();
      this.updateCount(cart.item_count);
    },
    async add(form, button) {
      const fd = new FormData(form);
      const ids = this.sectionIds();
      if (ids.length) {
        fd.append('sections', ids.join(','));
        fd.append('sections_url', window.location.pathname);
      }
      button && button.classList.add('is-loading');
      const scope = form.closest('[data-product]') || form;
      const errorBox = $('[data-form-error]', scope);
      if (errorBox) { errorBox.hidden = true; errorBox.textContent = ''; }
      try {
        const r = await fetch(`${window.theme.routes.cart_add_url}.js`, { method: 'POST', headers: { Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' }, body: fd });
        const data = await r.json();
        if (data.status) {
          const msg = data.description || data.message || window.theme.strings.cartError;
          if (errorBox) { errorBox.textContent = msg; errorBox.hidden = false; } else { toast(msg); }
          return;
        }
        const quick = $('#QuickView');
        if (quick && quick.open) closeDialog(quick);
        if (window.theme.cartType !== 'drawer' || !this.drawer()) {
          window.location.href = window.theme.routes.cart_url;
          return;
        }
        this.render(data.sections);
        await this.refreshCount();
        openDialog(this.drawer(), button);
        document.dispatchEvent(new CustomEvent('cart:added', { detail: data }));
      } catch (err) {
        if (errorBox) { errorBox.textContent = window.theme.strings.cartError; errorBox.hidden = false; }
      } finally {
        button && button.classList.remove('is-loading');
      }
    },
    async change(line, quantity) {
      $$('[data-cart-items]').forEach((el) => el.classList.add('cart-is-updating'));
      try {
        const r = await fetch(`${window.theme.routes.cart_change_url}.js`, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ line, quantity, sections: this.sectionIds(), sections_url: window.location.pathname })
        });
        const cart = await r.json();
        if (cart.status) {
          const box = $('[data-cart-error]');
          if (box) { box.textContent = cart.description || window.theme.strings.cartError; box.hidden = false; }
          return;
        }
        this.render(cart.sections);
        this.updateCount(cart.item_count);
      } finally {
        $$('[data-cart-items]').forEach((el) => el.classList.remove('cart-is-updating'));
      }
    },
    saveNote: debounce((note) => {
      fetch(`${window.theme.routes.cart_update_url}.js`, { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ note }) });
    }, 500)
  };

  document.addEventListener('submit', (e) => {
    const form = e.target.closest('form[data-ajax-cart]');
    if (!form) return;
    e.preventDefault();
    Cart.add(form, e.submitter || $('[type=submit]', form));
  });

  document.addEventListener('click', (e) => {
    const opener = e.target.closest('[data-cart-open]');
    if (opener && Cart.drawer() && window.theme.cartType === 'drawer') {
      e.preventDefault();
      openDialog(Cart.drawer(), opener);
      return;
    }
    const remove = e.target.closest('[data-cart-remove]');
    if (remove) { e.preventDefault(); Cart.change(parseInt(remove.dataset.cartRemove, 10), 0); }
  });

  const lineChange = debounce((input) => Cart.change(parseInt(input.dataset.cartLine, 10), Math.max(0, parseInt(input.value, 10) || 0)), 350);
  document.addEventListener('change', (e) => {
    const input = e.target.closest('[data-cart-line]');
    if (input) lineChange(input);
  });
  document.addEventListener('input', (e) => {
    if (e.target.matches('[data-cart-note]')) Cart.saveNote(e.target.value);
  });

  function initGallery(root) {
    const gallery = $('[data-gallery]', root);
    if (!gallery) return null;
    const slides = $$('.gallery__slide', gallery);
    const thumbs = $$('.gallery__thumb', gallery);
    const counter = $('[data-gallery-counter]', gallery);
    let current = Math.max(0, slides.findIndex((s) => s.classList.contains('is-active')));
    if (!slides.some((s) => s.classList.contains('is-active')) && slides[0]) slides[0].classList.add('is-active');
    const goTo = (index) => {
      if (!slides.length) return;
      current = (index + slides.length) % slides.length;
      gallery.classList.remove('is-zoomed');
      slides.forEach((s, i) => s.classList.toggle('is-active', i === current));
      thumbs.forEach((t, i) => t.setAttribute('aria-current', i === current ? 'true' : 'false'));
      if (counter) counter.textContent = `${current + 1} / ${slides.length}`;
      $$('video', gallery).forEach((v) => v.pause());
      const thumb = thumbs[current];
      if (thumb && thumb.parentElement && thumb.parentElement.parentElement) {
        const list = thumb.parentElement.parentElement;
        list.scrollTo({ top: thumb.offsetTop - list.clientHeight / 2, left: thumb.offsetLeft - list.clientWidth / 2, behavior: 'smooth' });
      }
    };
    thumbs.forEach((t, i) => t.addEventListener('click', () => goTo(i)));
    $('[data-gallery-prev]', gallery)?.addEventListener('click', () => goTo(current - 1));
    $('[data-gallery-next]', gallery)?.addEventListener('click', () => goTo(current + 1));
    const main = $('.gallery__main', gallery);
    let startX = 0;
    main?.addEventListener('touchstart', (e) => { startX = e.touches[0].clientX; }, { passive: true });
    main?.addEventListener('touchend', (e) => {
      const dx = e.changedTouches[0].clientX - startX;
      if (Math.abs(dx) > 40 && !gallery.classList.contains('is-zoomed')) goTo(current + (dx < 0 ? 1 : -1));
    });
    if (gallery.hasAttribute('data-zoom') && window.matchMedia('(hover: hover)').matches) {
      main?.addEventListener('click', (e) => {
        if (e.target.tagName !== 'IMG') return;
        gallery.classList.toggle('is-zoomed');
      });
      main?.addEventListener('mousemove', (e) => {
        if (!gallery.classList.contains('is-zoomed')) return;
        const r = main.getBoundingClientRect();
        gallery.style.setProperty('--zx', `${((e.clientX - r.left) / r.width) * 100}%`);
        gallery.style.setProperty('--zy', `${((e.clientY - r.top) / r.height) * 100}%`);
      });
    }
    return {
      goToMedia(mediaId) {
        const idx = slides.findIndex((s) => s.dataset.mediaId === String(mediaId));
        if (idx > -1) goTo(idx);
      }
    };
  }

  function loadPickup(root, variantId) {
    const el = $('[data-pickup]', root);
    if (!el || !variantId) return;
    fetch(`${el.dataset.root}variants/${variantId}/?section_id=pickup-availability`)
      .then((r) => r.text())
      .then((html) => {
        const content = $('[data-pickup-content]', parse(html));
        el.innerHTML = content ? content.innerHTML : '';
      })
      .catch(() => { el.innerHTML = ''; });
  }

  function initProduct(root) {
    if (root.dataset.ready) return;
    root.dataset.ready = 'true';
    const sectionId = root.dataset.sectionId;
    const url = root.dataset.url;
    const picker = $('[data-variant-picker]', root);
    const jsonEl = $('[data-variants]', root);
    const variants = jsonEl ? JSON.parse(jsonEl.textContent) : [];
    const gallery = initGallery(root);
    const pickupEl = $('[data-pickup]', root);
    if (pickupEl) loadPickup(root, pickupEl.dataset.variantId);

    const selectedOptions = () => {
      const values = [];
      $$('fieldset.option, .field.option', picker).forEach((group) => {
        const checked = $('input:checked', group);
        const select = $('select', group);
        values.push(checked ? checked.value : select ? select.value : null);
      });
      return values;
    };

    let controller;
    if (picker && variants.length) {
      picker.addEventListener('change', async () => {
        const selected = selectedOptions();
        $$('[data-selected-option]', picker).forEach((el, i) => { el.textContent = selected[i] || ''; });
        const variant = variants.find((v) => v.options.every((o, i) => o === selected[i]));
        const buttons = $$('[data-add-button]', root.closest('.shopify-section') || root);
        const setButtons = (disabled, label) => buttons.forEach((b) => {
          b.disabled = disabled;
          const span = $('span', b);
          if (span) span.textContent = label;
        });
        if (!variant) { setButtons(true, window.theme.strings.unavailable); return; }
        $$('form input[name="id"]', root).forEach((i) => { i.value = variant.id; });
        if (variant.featured_media && gallery) gallery.goToMedia(variant.featured_media.id);
        if (root.dataset.updateUrl === 'true') window.history.replaceState({}, '', `${url}?variant=${variant.id}`);
        setButtons(!variant.available, variant.available ? window.theme.strings.addToCart : window.theme.strings.soldOut);
        loadPickup(root, variant.id);
        if (controller) controller.abort();
        controller = new AbortController();
        try {
          const r = await fetch(`${url}?variant=${variant.id}&section_id=${sectionId}`, { signal: controller.signal });
          const doc = parse(await r.text());
          $$('[data-update]', root).forEach((el) => {
            const fresh = $(`[data-update="${el.dataset.update}"]`, doc);
            if (fresh) { el.innerHTML = fresh.innerHTML; el.hidden = fresh.hidden; }
          });
          const freshOptions = $('[data-variant-picker]', doc);
          if (freshOptions) {
            $$('input[type=radio]', picker).forEach((input) => {
              const match = $(`#${CSS.escape(input.id)}`, freshOptions);
              if (match) input.classList.toggle('is-unavailable', match.classList.contains('is-unavailable'));
            });
          }
        } catch (err) {}
      });
    }

    const mainBtn = $('[data-main-add]', root);
    const sticky = $('[data-sticky-buy]', root);
    if (mainBtn && sticky && 'IntersectionObserver' in window) {
      new IntersectionObserver(([entry]) => {
        const show = !entry.isIntersecting && entry.boundingClientRect.top < 0;
        sticky.classList.toggle('is-visible', show);
        sticky.setAttribute('aria-hidden', show ? 'false' : 'true');
        $$('button', sticky).forEach((b) => { b.tabIndex = show ? 0 : -1; });
      }).observe(mainBtn);
    }
    initRecommendations(root);
  }

  document.addEventListener('click', async (e) => {
    const trigger = e.target.closest('[data-quick-view]');
    if (!trigger) return;
    e.preventDefault();
    const modal = $('#QuickView');
    const content = $('[data-quick-view-content]', modal);
    if (!modal || !content) { window.location.href = trigger.dataset.quickView; return; }
    trigger.classList.add('is-loading');
    try {
      const r = await fetch(`${trigger.dataset.quickView}${trigger.dataset.quickView.includes('?') ? '&' : '?'}section_id=quick-view`);
      const doc = parse(await r.text());
      const product = $('[data-product]', doc);
      if (!product) { window.location.href = trigger.dataset.quickView; return; }
      content.innerHTML = '';
      content.appendChild(product);
      const cartDrawer = Cart.drawer();
      if (cartDrawer && cartDrawer.open) closeDialog(cartDrawer);
      openDialog(modal, trigger);
      initProduct(product);
      if (window.Shopify && window.Shopify.PaymentButton) window.Shopify.PaymentButton.init();
    } catch (err) {
      window.location.href = trigger.dataset.quickView;
    } finally {
      trigger.classList.remove('is-loading');
    }
  });

  function initRecommendations(scope = document) {
    $$('[data-recommendations]:not([data-loaded])', scope).forEach(async (el) => {
      el.dataset.loaded = 'true';
      try {
        const r = await fetch(el.dataset.url);
        const doc = parse(await r.text());
        const fresh = $('[data-recommendations]', doc);
        if (fresh && fresh.innerHTML.trim().length) {
          el.innerHTML = fresh.innerHTML;
          initReveal(el);
        } else if (el.classList.contains('complementary')) {
          el.remove();
        }
      } catch (err) {}
    });
  }

  function initPredictive() {
    const input = $('[data-predictive-input]');
    const results = $('[data-predictive-results]');
    if (!input || !results || input.hasAttribute('data-predictive-off')) return;
    let controller;
    const search = debounce(async () => {
      const q = input.value.trim();
      if (!q) { results.innerHTML = ''; input.setAttribute('aria-expanded', 'false'); return; }
      if (controller) controller.abort();
      controller = new AbortController();
      try {
        const params = new URLSearchParams({ q, section_id: 'predictive-search', 'resources[type]': 'product,collection,query,page,article', 'resources[limit]': '6', 'resources[options][unavailable_products]': 'last' });
        const r = await fetch(`${window.theme.routes.predictive_search_url}?${params}`, { signal: controller.signal });
        const content = $('[data-predictive-content]', parse(await r.text()));
        results.innerHTML = content ? content.innerHTML : '';
        input.setAttribute('aria-expanded', content ? 'true' : 'false');
      } catch (err) {}
    }, 220);
    input.addEventListener('input', search);
    input.addEventListener('keydown', (e) => {
      const options = $$('a.predictive__link, a.predictive__product, a.predictive__all', results);
      if (!options.length || !['ArrowDown', 'ArrowUp'].includes(e.key)) return;
      e.preventDefault();
      const idx = options.findIndex((o) => o.getAttribute('aria-selected') === 'true');
      options.forEach((o) => o.removeAttribute('aria-selected'));
      const next = e.key === 'ArrowDown' ? (idx + 1) % options.length : (idx - 1 + options.length) % options.length;
      options[next].setAttribute('aria-selected', 'true');
      options[next].focus();
    });
  }

  function initFacets(scope) {
    $$('form[data-facets]:not([data-bound])', scope).forEach((form) => {
      form.dataset.bound = 'true';
      const submit = debounce(() => {
        const params = new URLSearchParams(new FormData(form));
        for (const [k, v] of Array.from(params.entries())) { if (v === '') params.delete(k); }
        window.location.href = `${form.action}?${params.toString()}`;
      }, 350);
      form.addEventListener('change', (e) => { if (!e.target.matches('input[type=number]')) submit(); });
      form.addEventListener('submit', (e) => { e.preventDefault(); submit(); });
    });
    $$('[data-sort]:not([data-bound])', scope).forEach((sel) => {
      sel.dataset.bound = 'true';
      sel.addEventListener('change', () => {
        const params = new URLSearchParams(window.location.search);
        params.set('sort_by', sel.value);
        params.delete('page');
        window.location.search = params.toString();
      });
    });
  }
  document.addEventListener('click', (e) => {
    if (e.target.closest('[data-facets-open]')) { $('[data-facets-panel]')?.classList.add('is-open'); document.documentElement.style.overflow = 'hidden'; }
    if (e.target.closest('[data-facets-close]')) { $('[data-facets-panel]')?.classList.remove('is-open'); document.documentElement.style.overflow = ''; }
  });

  function initSlideshow(scope) {
    $$('[data-slideshow]:not([data-bound])', scope).forEach((el) => {
      el.dataset.bound = 'true';
      const slides = $$('.slideshow__slide', el);
      const dots = $$('[data-slide-to]', el);
      if (slides.length < 2) return;
      let index = 0;
      let timer;
      let playing = el.dataset.autoplay === 'true' && !reducedMotion;
      const go = (i) => {
        index = (i + slides.length) % slides.length;
        slides.forEach((s, n) => { s.classList.toggle('is-active', n === index); s.setAttribute('aria-hidden', n === index ? 'false' : 'true'); $$('a, button', s).forEach((a) => { a.tabIndex = n === index ? 0 : -1; }); });
        dots.forEach((d, n) => d.setAttribute('aria-current', n === index ? 'true' : 'false'));
      };
      const start = () => { clearInterval(timer); if (playing) timer = setInterval(() => go(index + 1), (parseInt(el.dataset.speed, 10) || 6) * 1000); };
      dots.forEach((d) => d.addEventListener('click', () => { go(parseInt(d.dataset.slideTo, 10)); start(); }));
      $('[data-slide-prev]', el)?.addEventListener('click', () => { go(index - 1); start(); });
      $('[data-slide-next]', el)?.addEventListener('click', () => { go(index + 1); start(); });
      const pause = $('[data-slide-pause]', el);
      pause?.addEventListener('click', () => {
        playing = !playing;
        pause.setAttribute('aria-label', playing ? pause.dataset.labelPause : pause.dataset.labelPlay);
        pause.innerHTML = playing ? '<svg class="icon" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.4" aria-hidden="true"><path d="M8 5v14M16 5v14"/></svg>' : '<svg class="icon" width="16" height="16" viewBox="0 0 24 24" aria-hidden="true"><path d="M8 5.5v13l11-6.5z" fill="currentColor"/></svg>';
        start();
      });
      el.addEventListener('focusin', () => clearInterval(timer));
      el.addEventListener('focusout', start);
      let sx = 0;
      el.addEventListener('touchstart', (e) => { sx = e.touches[0].clientX; }, { passive: true });
      el.addEventListener('touchend', (e) => { const dx = e.changedTouches[0].clientX - sx; if (Math.abs(dx) > 50) { go(index + (dx < 0 ? 1 : -1)); start(); } });
      go(0);
      start();
    });
  }

  function initCountdown(scope) {
    $$('[data-countdown]:not([data-bound])', scope).forEach((el) => {
      el.dataset.bound = 'true';
      const raw = el.dataset.countdown.trim().replace(' ', 'T');
      const end = new Date(raw.length <= 10 ? `${raw}T23:59:59` : raw).getTime();
      if (Number.isNaN(end)) { el.hidden = true; return; }
      const parts = { days: $('[data-days]', el), hours: $('[data-hours]', el), minutes: $('[data-minutes]', el), seconds: $('[data-seconds]', el) };
      const pad = (n) => String(n).padStart(2, '0');
      const tick = () => {
        const diff = end - Date.now();
        if (diff <= 0) {
          clearInterval(timer);
          if (el.dataset.hideExpired === 'true') $('.countdown', el).hidden = true;
          $('[data-expired]', el).hidden = false;
          return;
        }
        parts.days.textContent = pad(Math.floor(diff / 86400000));
        parts.hours.textContent = pad(Math.floor((diff / 3600000) % 24));
        parts.minutes.textContent = pad(Math.floor((diff / 60000) % 60));
        parts.seconds.textContent = pad(Math.floor((diff / 1000) % 60));
      };
      const timer = setInterval(tick, 1000);
      tick();
    });
  }

  document.addEventListener('click', (e) => {
    const play = e.target.closest('[data-video-play]');
    if (!play) return;
    const wrap = play.closest('[data-video]');
    const tpl = $('[data-video-template]', wrap);
    if (!tpl) return;
    wrap.innerHTML = '';
    wrap.appendChild(tpl.content.cloneNode(true));
    const v = $('video', wrap);
    if (v) v.play();
  });

  function initReveal(scope = document) {
    const els = $$('.reveal:not(.is-visible)', scope);
    if (!('IntersectionObserver' in window) || reducedMotion) { els.forEach((el) => el.classList.add('is-visible')); return; }
    const io = new IntersectionObserver((entries) => {
      entries.forEach((en) => { if (en.isIntersecting) { en.target.classList.add('is-visible'); io.unobserve(en.target); } });
    }, { rootMargin: '0px 0px -8% 0px' });
    els.forEach((el) => io.observe(el));
  }

  function initTabs(scope) {
    $$('[data-tabs]:not([data-bound])', scope).forEach((root) => {
      root.dataset.bound = 'true';
      const tabs = $$('[role=tab]', root);
      const select = (tab, focus) => {
        tabs.forEach((t) => {
          const on = t === tab;
          t.setAttribute('aria-selected', on ? 'true' : 'false');
          t.tabIndex = on ? 0 : -1;
          const panel = document.getElementById(t.getAttribute('aria-controls'));
          if (panel) panel.hidden = !on;
        });
        if (focus) tab.focus();
        initReveal(root);
      };
      tabs.forEach((t, i) => {
        t.addEventListener('click', () => select(t));
        t.addEventListener('keydown', (e) => {
          if (e.key === 'ArrowRight') { e.preventDefault(); select(tabs[(i + 1) % tabs.length], true); }
          if (e.key === 'ArrowLeft') { e.preventDefault(); select(tabs[(i - 1 + tabs.length) % tabs.length], true); }
        });
      });
    });
  }

  function initLook(scope) {
    $$('[data-look]:not([data-bound])', scope).forEach((root) => {
      root.dataset.bound = 'true';
      const spots = $$('[data-hotspot]', root);
      const items = $$('[data-look-item]', root);
      const activate = (i) => {
        spots.forEach((s, n) => s.setAttribute('aria-pressed', n === i ? 'true' : 'false'));
        items.forEach((it, n) => it.classList.toggle('is-active', n === i));
      };
      spots.forEach((s, i) => s.addEventListener('click', () => { activate(i); items[i]?.scrollIntoView({ block: 'nearest', behavior: 'smooth' }); }));
      items.forEach((it, i) => it.addEventListener('mouseenter', () => activate(i)));
    });
  }

  function init(scope = document) {
    initTabs(scope);
    initLook(scope);
    initAnnouncement(scope);
    $$('[data-product]', scope).forEach((el) => initProduct(el));
    initRecommendations(scope);
    initFacets(scope);
    initSlideshow(scope);
    initCountdown(scope);
    initReveal(scope);
  }

  document.addEventListener('DOMContentLoaded', () => { init(); initPredictive(); });
  document.addEventListener('shopify:section:load', (e) => init(e.target));
  document.addEventListener('shopify:block:select', (e) => {
    const slide = e.target.closest('.slideshow__slide');
    if (slide) {
      const show = slide.closest('[data-slideshow]');
      const i = $$('.slideshow__slide', show).indexOf(slide);
      $$('[data-slide-to]', show)[i]?.click();
    }
  });
})();
